export const sheetStyles = `
.filter-sheet {
  background: #ffffff;
  color: #1f2328;
  box-shadow: -12px 0 32px rgba(15, 20, 30, 0.08);
  border-left: 1px solid #eceef2;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.filter-sheet .offcanvas-body {
  flex: 1 1 auto;
  overflow: hidden;
}
/* Transparent backdrop — still closes on click, but list stays visible
   so users see facet changes apply in real time. */
.filter-sheet-backdrop.offcanvas-backdrop {
  background-color: rgba(15, 20, 30, 0.08);
}
.filter-sheet-backdrop.offcanvas-backdrop.show {
  opacity: 1;
}

.filter-sheet .fs-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eceef2;
  display: flex;
  align-items: center;
  min-height: 56px;
}
.filter-sheet .fs-header-actions {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.filter-sheet .fs-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2328;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}
.filter-sheet .fs-header-count {
  font-size: 11px;
  font-weight: 600;
  color: #525966;
  background: #f1f3f6;
  padding: 2px 8px;
  border-radius: 999px;
  line-height: 14px;
}
.filter-sheet .fs-close {
  border: 0;
  background: transparent;
  color: #525966;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.filter-sheet .fs-close:hover { background: #f1f3f6; color: #1f2328; }
.filter-sheet .fs-clear-link {
  border: 0;
  background: transparent;
  color: #525966;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 6px;
  cursor: pointer;
  border-radius: 6px;
}
.filter-sheet .fs-clear-link:hover {
  color: #0b57c8;
  background: #eff5ff;
}
.filter-sheet .fs-apply-btn {
  border: 0;
  background: #0b57c8;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 12px;
  cursor: pointer;
  border-radius: 6px;
}
.filter-sheet .fs-apply-btn:hover {
  background: #0848a8;
}

.filter-sheet .fs-scroll {
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
}

.filter-sheet .fs-primary {
  padding: 18px 20px 6px;
}

/* ------------ Field ------------ */
.filter-sheet .fs-field {
  margin-bottom: 0;
  padding-bottom: 18px;
  border-bottom: 1px solid #eceef2;
  padding-top: 18px;
}
.filter-sheet .fs-field:first-child { padding-top: 0; }
.filter-sheet .fs-field:last-child { border-bottom: none; padding-bottom: 0; }
.filter-sheet .fs-field-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 6px;
}
.filter-sheet .fs-field-label {
  font-size: 12px;
  font-weight: 600;
  color: #3d4350;
  margin: 0 0 8px;
  display: block;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.filter-sheet .fs-field-row .fs-field-label { margin-bottom: 0; }
.filter-sheet .fs-field-summary {
  font-size: 11px;
  color: #8b93a3;
  font-weight: 500;
}

/* ------------ Input group ------------ */
.filter-sheet .fs-input {
  border: 1px solid #dce0e6;
  border-radius: 7px;
  overflow: hidden;
  background: #fff;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.filter-sheet .fs-input:focus-within {
  border-color: #8bb8f9;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
}
.filter-sheet .fs-input .input-group-text {
  background: transparent;
  border: 0;
  color: #8b93a3;
  padding: 0 2px 0 12px;
}
.filter-sheet .fs-input .form-control {
  border: 0;
  box-shadow: none;
  font-size: 13px;
  padding: 9px 10px;
  background: transparent;
}
.filter-sheet .fs-input .form-control:focus {
  box-shadow: none;
  border: 0;
}
.filter-sheet .fs-input-clear {
  border: 0 !important;
  background: transparent !important;
  color: #8b93a3 !important;
  padding: 0 10px !important;
  text-decoration: none !important;
  display: inline-flex;
  align-items: center;
}
.filter-sheet .fs-input-clear:hover { color: #1f2328 !important; }
.filter-sheet .fs-title-suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% - 8px);
  width: auto;
  max-height: 360px;
  overflow: auto;
  z-index: 1090;
  box-sizing: border-box;
}
.filter-sheet .fs-field-suggest { position: relative; }
.filter-sheet .fs-title-suggestion-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #eceef2;
  cursor: pointer;
}
.filter-sheet .fs-title-suggestion-item:last-child { border-bottom: 0; }
.filter-sheet .fs-title-thumb {
  width: 96px;
  min-width: 96px;
}
.filter-sheet .fs-title-duration {
  position: absolute;
  top: auto;
  left: auto;
  right: 0;
  bottom: 0;
  width: auto !important;
  height: auto !important;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 11px;
  line-height: 1;
  padding: 3px 5px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.filter-sheet .fs-title-meta {
  flex: 1 1 auto;
  min-width: 0;
}
.filter-sheet .fs-title-text {
  font-size: 10px;
  font-weight: 500;
  color: #1f2328;
  line-height: 1.28;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-sheet .fs-title-sub {
  display: block;
  margin-top: 6px;
  color: #6b7280;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-sheet .fs-title-status {
  margin-left: auto;
  flex: 0 0 auto;
}

/* ------------ Entity autocomplete (Uploader / Agency) ------------ */
.filter-sheet .fs-entity-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 6px;
}
.filter-sheet .fs-entity-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 4px 3px 8px;
  background: #eff5ff;
  color: #0b57c8;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
}
.filter-sheet .fs-entity-chip-label {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-sheet .fs-entity-chip-remove {
  border: 0;
  background: transparent;
  color: #0b57c8;
  padding: 2px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.filter-sheet .fs-entity-chip-remove:hover {
  background: rgba(11, 87, 200, 0.12);
}
.filter-sheet .fs-entity-input-wrap {
  position: relative;
}
.filter-sheet .fs-entity-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1080;
  background: #fff;
  border: 1px solid #eceef2;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 20, 30, 0.12);
  padding: 4px;
  max-height: 220px;
  overflow-y: auto;
}
.filter-sheet .fs-entity-item {
  width: 100%;
  padding: 7px 10px;
  border: 0;
  background: transparent;
  color: #1f2328;
  font-size: 13px;
  text-align: left;
  border-radius: 6px;
  cursor: pointer;
  transition: background 120ms ease;
}
.filter-sheet .fs-entity-item:hover { background: #eff5ff; color: #0b57c8; }
.filter-sheet .fs-entity-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #8b93a3;
}

/* ------------ Select ------------ */
.filter-sheet .fs-field .form-select,
.filter-sheet .fs-field .form-control {
  font-size: 13px;
  border-color: #dce0e6;
  border-radius: 7px;
}
.filter-sheet .fs-field .form-select:focus,
.filter-sheet .fs-field .form-control:focus {
  border-color: #8bb8f9;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
}

/* ------------ Date range trigger + popover ------------ */
.filter-sheet .fs-daterange { position: relative; }
.filter-sheet .fs-daterange-trigger {
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #dce0e6;
  border-radius: 7px;
  background: #fff;
  color: #525966;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.filter-sheet .fs-daterange-trigger:hover {
  border-color: #c7ccd6;
}
.filter-sheet .fs-daterange-trigger[aria-expanded="true"],
.filter-sheet .fs-daterange-trigger.has-value {
  border-color: #8bb8f9;
  color: #1f2328;
}
.filter-sheet .fs-daterange-icon { color: #8b93a3; flex-shrink: 0; }
.filter-sheet .fs-daterange-text { flex: 1; text-align: left; }
.filter-sheet .fs-daterange-clear {
  color: #8b93a3;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
}
.filter-sheet .fs-daterange-clear:hover { color: #1f2328; background: #f1f3f6; }

/* Popover sits under the trigger, right-aligned so it never clips past the
   sheet's right edge. Width matches the calendar (~260px) so horizontal
   overflow from a 360px content area is impossible. */
.filter-sheet .fs-daterange-popover {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 1080;
  width: 272px;
  background: #fff;
  border: 1px solid #eceef2;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(15, 20, 30, 0.12),
    0 2px 6px rgba(15, 20, 30, 0.06);
  padding: 8px 8px 6px;
}
.filter-sheet .fs-daterange-presets-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  margin-bottom: 8px;
}
.filter-sheet .fs-daterange-chip {
  border: 1px solid #dce0e6;
  background: #fff;
  color: #525966;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 6px;
  border-radius: 999px;
  cursor: pointer;
  transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
  white-space: nowrap;
  line-height: 1.4;
  font-family: inherit;
  text-align: center;
}
.filter-sheet .fs-daterange-chip:hover {
  border-color: #0b57c8;
  color: #0b57c8;
  background: #eff5ff;
}
.filter-sheet .fs-daterange-chip.is-active {
  background: #0b57c8;
  border-color: #0b57c8;
  color: #ffffff;
}
.filter-sheet .fs-daterange-row {
  display: flex;
  gap: 8px;
}
.filter-sheet .fs-daterange-row > * {
  flex: 1;
  min-width: 0;
}
/* Hide the above-input label wrapper that UnifiedDateTimePicker always renders
   when label="" — avoids dead whitespace above each date input. */
.filter-sheet .fs-daterange-row .d-flex.align-items-center.gap-1.p-1 {
  display: none !important;
}
.filter-sheet .fs-daterange-cal {
  display: flex;
  justify-content: center;
}
.filter-sheet .fs-daterange-foot {
  min-height: 24px;
  padding: 4px 4px 0;
  display: flex;
  justify-content: flex-end;
}
.filter-sheet .fs-daterange-clear-link {
  border: 0;
  background: transparent;
  color: #525966;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 5px;
  cursor: pointer;
}
.filter-sheet .fs-daterange-clear-link:hover {
  color: #0b57c8;
  background: #eff5ff;
}

/* Restyle react-datepicker visually — keep its native table grid for the
   day cells so row alignment stays correct. */
.filter-sheet .react-datepicker {
  border: 0;
  font-family: inherit;
  background: #fff;
  font-size: 12px;
}
.filter-sheet .react-datepicker__header {
  background: #fff;
  border-bottom: 0;
  padding: 4px 0 0;
}
.filter-sheet .react-datepicker__current-month {
  font-size: 13px;
  font-weight: 600;
  color: #1f2328;
  margin-bottom: 4px;
}
.filter-sheet .react-datepicker__day-name,
.filter-sheet .react-datepicker__day {
  width: 2rem;
  line-height: 2rem;
  margin: 0.1rem;
  font-size: 12px;
}
.filter-sheet .react-datepicker__day-name {
  color: #8b93a3;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.filter-sheet .react-datepicker__day {
  color: #1f2328;
  border-radius: 6px;
}
.filter-sheet .react-datepicker__day:hover {
  background: #eef5ff;
  color: #0b57c8;
}
.filter-sheet .react-datepicker__day--outside-month { color: #c7ccd6; }
.filter-sheet .react-datepicker__day--disabled {
  color: #e1e4ea;
  cursor: not-allowed;
}
.filter-sheet .react-datepicker__day--disabled:hover { background: transparent; }
.filter-sheet .react-datepicker__day--in-range,
.filter-sheet .react-datepicker__day--in-selecting-range {
  background: #eef5ff;
  color: #0b57c8;
}
.filter-sheet .react-datepicker__day--range-start,
.filter-sheet .react-datepicker__day--range-end,
.filter-sheet .react-datepicker__day--selected,
.filter-sheet .react-datepicker__day--selecting-range-start,
.filter-sheet .react-datepicker__day--selecting-range-end {
  background: #0b57c8 !important;
  color: #ffffff !important;
}
.filter-sheet .react-datepicker__day--keyboard-selected {
  background: transparent;
  color: #1f2328;
}
.filter-sheet .react-datepicker__navigation { top: 6px; }
.filter-sheet .react-datepicker__navigation-icon::before {
  border-color: #8b93a3;
  border-width: 1.5px 1.5px 0 0;
}
.filter-sheet .react-datepicker__triangle { display: none; }

/* ------------ Multi picker ------------ */
.filter-sheet .fs-multi {
  border: 1px solid #dce0e6;
  border-radius: 7px;
  background: #fff;
  overflow: hidden;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.filter-sheet .fs-multi:focus-within {
  border-color: #8bb8f9;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
}
.filter-sheet .fs-multi-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-bottom: 1px solid #eef0f3;
}
.filter-sheet .fs-multi-search-icon { color: #8b93a3; flex-shrink: 0; }
.filter-sheet .fs-multi-search-input {
  flex: 1;
  border: 0;
  outline: none;
  font-size: 12px;
  background: transparent;
  color: #1f2328;
  padding: 2px 0;
}
.filter-sheet .fs-multi-search-input::placeholder { color: #b5bcc9; }
.filter-sheet .fs-multi-clear {
  border: 0;
  background: transparent;
  color: #525966;
  font-size: 11px;
  cursor: pointer;
  padding: 0;
}
.filter-sheet .fs-multi-clear:hover { color: #1f2328; }

.filter-sheet .fs-multi-list {
  max-height: 180px;
  overflow-y: auto;
  padding: 4px 0;
}
.filter-sheet .fs-multi-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #8b93a3;
}
.filter-sheet .fs-multi-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 12px;
  background: transparent;
  border: 0;
  font-size: 13px;
  color: #1f2328;
  text-align: left;
  cursor: pointer;
  line-height: 1.3;
}
.filter-sheet .fs-multi-item:hover { background: #f7f8fa; }
.filter-sheet .fs-multi-item.is-selected {
  background: #eef5ff;
  color: #0b57c8;
  font-weight: 500;
}
.filter-sheet .fs-multi-item-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-sheet .fs-multi-item-check { color: #0b57c8; flex-shrink: 0; }

/* ------------ Platform grid (publishing destinations) ------------ */
.filter-sheet .fs-platforms {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.filter-sheet .fs-platform {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #1f2328;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;
}
.filter-sheet .fs-platform:hover { background: #f4f6fa; }
.filter-sheet .fs-platform.is-selected {
  background: #eff5ff;
  color: #0b57c8;
}
.filter-sheet .fs-platform-check {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid #c7ccd6;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  transition: background 120ms ease, border-color 120ms ease;
}
.filter-sheet .fs-platform.is-selected .fs-platform-check {
  background: #0b57c8;
  border-color: #0b57c8;
}
.filter-sheet .fs-platform-logo {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 3px;
}
.filter-sheet .fs-platform-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.filter-sheet .fs-field-reset {
  border: 0;
  background: transparent;
  color: #0b57c8;
  font-size: 11px;
  font-weight: 500;
  padding: 0;
  cursor: pointer;
}
.filter-sheet .fs-field-reset:hover { text-decoration: underline; }

/* ------------ Generic tile grid (status / source / team / content type) ---- */
.filter-sheet .fs-tiles {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.filter-sheet .fs-tile {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #1f2328;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;
}
.filter-sheet .fs-tile:hover { background: #f4f6fa; }
.filter-sheet .fs-tile.is-selected {
  background: #eff5ff;
  color: #0b57c8;
}
.filter-sheet .fs-tile-check {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid #c7ccd6;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  transition: background 120ms ease, border-color 120ms ease;
}
.filter-sheet .fs-tile.is-selected .fs-tile-check {
  background: #0b57c8;
  border-color: #0b57c8;
}
.filter-sheet .fs-tile-radio .fs-tile-check {
  border-radius: 50%;
  background: #fff;
  border-color: #c7ccd6;
}
.filter-sheet .fs-tile-radio.is-selected .fs-tile-check {
  background: #fff;
  border-color: #0b57c8;
}
.filter-sheet .fs-tile-radio.is-selected .fs-tile-check::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0b57c8;
}
.filter-sheet .fs-tile-label {
  flex: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-sheet .fs-tile-badge {
  width: 26px;
  height: 22px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  flex-shrink: 0;
  line-height: 1;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.08);
}
.filter-sheet .fs-tile-badge-neutral {
  background: #eceef2;
  color: #525966;
  font-size: 11px;
  letter-spacing: 0;
  box-shadow: none;
}

/* Tile-grid search + see-more affordances. Used by the Team filter when more
   than N teams are accessible. */
.filter-sheet .fs-tilegrid-wrap { min-width: 0; }
.filter-sheet .fs-tilegrid-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  margin-bottom: 6px;
  background: #f4f6fa;
  border-radius: 7px;
}
.filter-sheet .fs-tilegrid-search-icon {
  color: #8b93a3;
  flex-shrink: 0;
}
.filter-sheet .fs-tilegrid-search-input {
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 12px;
  color: #1f2328;
  padding: 2px 0;
}
.filter-sheet .fs-tilegrid-search-input::placeholder { color: #b5bcc9; }
.filter-sheet .fs-tilegrid-search-clear {
  border: 0;
  background: transparent;
  color: #8b93a3;
  padding: 2px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.filter-sheet .fs-tilegrid-search-clear:hover { color: #1f2328; }
.filter-sheet .fs-tilegrid-empty {
  grid-column: 1 / -1;
  padding: 8px 10px;
  font-size: 12px;
  color: #8b93a3;
}
.filter-sheet .fs-tilegrid-toggle {
  margin-top: 6px;
  border: 0;
  background: transparent;
  color: #0b57c8;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 6px;
  border-radius: 5px;
  cursor: pointer;
}
.filter-sheet .fs-tilegrid-toggle:hover { background: #eff5ff; }

/* ------------ Duration range (operator + values) ------------ */
/* Operator-based filter following the B2B convention (Notion / Airtable /
   Salesforce): one operator dropdown followed by value inputs that adapt
   to the chosen operator, with compact shortcut chips below. */
.filter-sheet .fs-duration-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  min-width: 0;
  margin-top: 10px;
}
.filter-sheet .fs-duration-op {
  flex: 0 1 auto;
  min-width: 0;
  width: 110px;
  height: 34px;
  padding: 0 26px 0 10px;
  border: 1px solid #dce0e6;
  border-radius: 7px;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'><path d='M1 1l4 4 4-4' stroke='%238b93a3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  font-size: 13px;
  font-weight: 500;
  color: #1f2328;
  cursor: pointer;
  outline: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.filter-sheet .fs-duration-op:hover { border-color: #c7ccd6; }
.filter-sheet .fs-duration-op:focus {
  border-color: #0b57c8;
  box-shadow: 0 0 0 3px rgba(11, 87, 200, 0.10);
}
.filter-sheet .fs-duration-num {
  flex: 1 1 0;
  min-width: 0;
  width: 56px;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #dce0e6;
  border-radius: 7px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 600;
  color: #1f2328;
  text-align: center;
  outline: 0;
  transition: border-color 120ms ease, box-shadow 120ms ease;
  -moz-appearance: textfield;
}
.filter-sheet .fs-duration-num::-webkit-outer-spin-button,
.filter-sheet .fs-duration-num::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.filter-sheet .fs-duration-num::placeholder {
  color: #c7ccd6;
  font-weight: 400;
}
.filter-sheet .fs-duration-num:hover { border-color: #c7ccd6; }
.filter-sheet .fs-duration-num:focus {
  border-color: #0b57c8;
  box-shadow: 0 0 0 3px rgba(11, 87, 200, 0.10);
}
.filter-sheet .fs-duration-word {
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 400;
  color: #8b93a3;
  line-height: 1;
  padding: 0 2px;
}
.filter-sheet .fs-duration-unit {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 500;
  color: #8b93a3;
  margin-left: 2px;
  white-space: nowrap;
}

/* Shortcut chips — compact one-click common ranges */
.filter-sheet .fs-duration-shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.filter-sheet .fs-duration-chip {
  border: 1px solid #dce0e6;
  background: #fff;
  color: #525966;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 999px;
  cursor: pointer;
  transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
  white-space: nowrap;
  line-height: 1.4;
}
.filter-sheet .fs-duration-chip:hover {
  border-color: #0b57c8;
  color: #0b57c8;
  background: #eff5ff;
}
.filter-sheet .fs-duration-chip.is-active {
  background: #0b57c8;
  border-color: #0b57c8;
  color: #ffffff;
}
.filter-sheet .react-select__value-container {
  padding-left: 10px;
}
.filter-sheet .react-select__input-container {
  display: grid !important;
  grid-template-columns: 0px 1fr !important;
  flex: 1 1 0 !important;
  min-width: 0 !important;
  padding: 0;
  margin: 0;
}

/* ------------ Uploader quick presets (Me / My team) ------------ */
.filter-sheet .fs-uploader-presets {
  display: flex;
  gap: 6px;
  margin: 0 0 8px;
}
.filter-sheet .fs-uploader-chip {
  flex: 1;
  min-width: 0;
  max-width: 100px;
  border: 1px solid #dce0e6;
  background: #fff;
  color: #525966;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  font-family: inherit;
  text-align: center;
}
.filter-sheet .fs-uploader-chip:only-child {
  flex: 0 0 auto;
}
.filter-sheet .fs-uploader-chip:hover {
  border-color: #0b57c8;
  color: #0b57c8;
  background: #eff5ff;
}
.filter-sheet .fs-uploader-chip.is-active {
  background: #0b57c8;
  border-color: #0b57c8;
  color: #ffffff;
}

/* Team tile-grid search uses the same input style as text search fields */
.filter-sheet .fs-tilegrid-search-unified {
  margin: 0 0 10px;
}
`;
